import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './CreateProfile.module.css';
import LiefIcon from 'assets/images/liefIcons/send-feedback.svg';
import ProfileForm from 'containers/ProfileForm/ProfileForm';
import * as actions from 'store/actions';

class CreateProfile extends Component {
  componentDidMount() {
    if (this.props.signedInAs.UserId) {
      this.handleInitProfileForm();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.signedInAs.UserId && !prevProps.signedInAs.UserId) {
      this.handleInitProfileForm();
    }
    // Once profile is created, redirect user to /my-riza
    if (prevProps.signedInAs.ProfileStatus === 'NotComplete' && this.props.signedInAs.ProfileStatus !== 'NotComplete') {
      this.props.history.push('/my-riza');
    }
  }

  handleInitProfileForm = () => {
    this.props.onInitProfileForm(
      this.props.signedInAs.UserId,
      this.props.signedInAs.ImageURL,
      this.props.signedInAs.FirstName,
      this.props.signedInAs.LastName,
      this.props.signedInAs.NickName,
      this.props.signedInAs.DateBirthDay,
      this.props.signedInAs.Color,
      this.props.signedInAs.ProfileStatus,
      false,
      false,
    );
  };

  render() {
    const profileDataLoaded = !!this.props.editingProfile.FirstName;
    return (
      <div className={classes.CreateProfileContainer}>
        {profileDataLoaded ? (
          <div className={classes.FormContainer}>
            <div className={classes.CreateProfileCallOut}>
              <img src={LiefIcon} alt="send-feedback" className={classes.LiefIcon} />
              <h3>Last step! Add a short profile and we'll get you going on Riza!</h3>
            </div>
            <ProfileForm type="CreateProfile" />
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    signedInAs: state.user.signedInAs,
    editingProfile: state.user.editingProfile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInitProfileForm: (UserId, profileImageId, FirstName, LastName, NickName, DateBirthDay, Color, ProfileStatus, isManagedUser, ShowModal) =>
      dispatch(
        actions.initProfileForm(UserId, profileImageId, FirstName, LastName, NickName, DateBirthDay, Color, ProfileStatus, isManagedUser, ShowModal),
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateProfile);
